<template>
    <li class="no-padding no-margin w-100 h-100 d-flex align-items-center justify-content-center gap-10">
      <div class="free-credit-info" data-toggle="tooltip" data-placement="right" title="Credits" v-if="!isApi2Convert"><CoinSVGBlue /> {{ this.availableCredit }}</div>

      <div class="h-100 align-items-center p-header d-none d-md-inline-flex"  v-if="!isApi2Convert">

          <div class="h-100 align-items-center p-header-2 d-none d-md-inline-flex">
            <template v-if="useModalFlow === true">
                <span
                    class="btn font-weight-bold btn-login-outline btn-lg w-auto py-2"
                    data-user-button-login
                    @click.stop.prevent="clickLoginButton"
                >
                    <i class="fa fa-sign-in"></i> {{ textLoginButton }}
                </span>
            </template>
            <template v-else>
              <a
                  class="pr-4 font-weight-bold text-dark"
                  id="login-btn"
                  data-user-button-login
                  :href="linkLoginButton"
              >
                <i class="fa fa-sign-in"></i> {{ textLoginButton }}
              </a>
            </template>
          </div>
        </div>

      <div class="h-100 align-items-center p-header d-none d-md-inline-flex" v-if="isApi2Convert">
        <template v-if="useModalFlow === true">
                <span
                    class="pr-4 font-weight-bold text-dark cursor-pointer"
                    data-user-button-login
                    @click.stop.prevent="clickLoginButton"
                >
                    <i class="fa fa-sign-in"></i> {{ textLoginButton }}
                </span>
        </template>
        <template v-else>
          <a
              class="pr-4 font-weight-bold text-dark"
              id="login-btn"
              data-user-button-login
              :href="linkLoginButton"
          >
            <i class="fa fa-sign-in"></i> {{ textLoginButton }}
          </a>
        </template>
      </div>
        <div class="h-100 align-items-center p-header-2 d-none d-md-inline-flex">
            <template v-if="useModalFlow === true">
                <span
                    class="btn font-weight-bold btn-signup btn-lg w-auto py-2"
                    data-user-button-register
                    @click.stop.prevent="clickSignupButton"
                >
                    {{ textSignupButton }}
                </span>
            </template>
            <template v-else>
                <a
                    class="btn font-weight-bold btn-signup btn-lg w-auto py-2"
                    data-user-button-register
                    :id="idSignupButton"
                    :href="linkSignupButton"
                >
                    {{ textSignupButton }}
                </a>
            </template>
        </div>

        <a
            class="dropdown-toggle w-100 no-sm-border no-sm-border border-right nav-link bg-white d-xs-flex align-items-center h-100 d-flex d-sm-flex d-md-none d-lg-none pr-2 pr-sm-0"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            href="#"
        >
            <i class="fa fa-bars pr-2 fg-normal"></i>
            <span class="hidden-mobile text-normal">{{ 'Menu' | trans }}</span>
        </a>

        <div
            style="margin-top: -2px"
            class="pt-3 pb-3 pr-3 pl-3 dropdown-menu main-user-dropdown dropdown-menu-right dropdown-menu-hover w-100 border bg-white"
        >
            <div class="h-100 align-items-center">
                <template v-if="useModalFlow === true">
                    <span
                        class="pr-4 font-weight-bold text-dark btn btn-block btn-light"
                        @click.stop.prevent="clickLoginButton"
                        >{{ textLoginButton }}</span
                    >
                </template>
                <template v-else>
                    <a class="pr-4 font-weight-bold text-dark btn btn-block btn-light" :href="linkLoginButton">{{
                        textLoginButton
                    }}</a>
                </template>
            </div>

            <div class="h-100 align-items-center">
                <template v-if="useModalFlow === true">
                    <span
                        class="btn font-weight-bold bg-success text-white btn-block"
                        @click.stop.prevent="clickSignupButton"
                        >{{ textSignupButton }}</span
                    >
                </template>
                <template v-else>
                    <a
                        class="btn font-weight-bold bg-success text-white btn-block fg-white"
                        :id="idSignupButton"
                        :href="linkSignupButton"
                    >
                        {{ textSignupButton }}
                    </a>
                </template>
            </div>
        </div>
    </li>
</template>

<script>
import { translate } from '../../../../qaamgo/helper/translate';
import TransFilter from '../../../../qaamgo/modules/sat/components/mixins/TransFilter';
import { satGlobals } from '../../../../qaamgo/sat/helper/sat-globals';
import { translatePath } from '../../../../qaamgo/sat/helper/translate-path';
import { registerPaymentModalHelper } from '../../modal/register_payment_flow/register-payment-modal-helper';
import { pageStoreMixin } from '../../../store/page-store';
import CoinSVG from "../../../../qaamgo/modules/sat/components/form/icons/CoinSVG.vue";
import {userManager} from "../../user-manager";
import {projectHelper} from "../../../misc/project-helper";
import {EventBus as ResultPageEventBus} from "../../../../qaamgo/modules/sat/components/result_v2/events/event.bus";
import {EVENT_JOB_COMPLETE} from "../../../../qaamgo/modules/sat/components/result_v2/events/job.events";
import {
  EventBus as CreatorStudioEventBus
} from "../../../../qaamgo/modules/sat/components/aicreatorstudio/events/event.bus";
import {EVENT_CREDITS_UPDATE} from "../../../../qaamgo/modules/sat/components/aicreatorstudio/events/credits.events";
import CoinSVGWhite from "../../../../qaamgo/modules/sat/components/form/icons/CoinSVGWhite.vue";
import CoinSVGBlue from "../../../../qaamgo/modules/sat/components/form/icons/CoinSVGBlue.vue";

export default {
    name: 'UserButtonsAnonymousView',
  components: {CoinSVGBlue, CoinSVGWhite, CoinSVG},
    props: {
        useModalFlow: {
            type: Boolean,
            default: false,
        },
        enableFreeTrial: {
            type: Boolean,
            default: false,
        },
        links: {
            type: Object,
            default: {},
        },
    },
    mixins: [TransFilter, pageStoreMixin],
    computed: {
        textLoginButton() {
            return translate('Log In');
        },
        textSignupButton() {
            if (this.enableFreeTrial) {
                return translate('Free Trial');
            }

            return translate('Sign Up');
        },
        idSignupButton() {
            if (this.enableFreeTrial) {
                return 'free-trial-btn';
            }

            return 'signup-btn';
        },
        linkSignupButton() {
            let registerLink = this.links?.register ?? satGlobals.getMainUrl() + translatePath('/register');

            // if (this.enableFreeTrial) {
            //   return registerLink;
            // }

            return registerLink;
        },
        linkLoginButton() {
            let loginLink = this.links?.login ?? satGlobals.getMainUrl() + translatePath('/login');

            // if (this.enableFreeTrial) {
            //   return loginLink;
            // }

            return loginLink;
        },
    },
  created() {
    this.availableCredits();
    ResultPageEventBus.$on(EVENT_JOB_COMPLETE, () => {
      this.availableCredits();
    });
    CreatorStudioEventBus.$on(EVENT_CREDITS_UPDATE, () => {
      this.availableCredits();
    });
  },
    methods: {
      async availableCredits() {
        await userManager.getFreshUser();
        const getUser = await userManager.getUser();
        this.availableCredit = getUser.getAvailableCredits();
      },
        clickLoginButton() {
            this.store.userPaymentModal.setSkipPayment(true);
            registerPaymentModalHelper.openLogin();
        },
        clickSignupButton() {
            this.store.userPaymentModal.setSkipPayment(true);
            registerPaymentModalHelper.openRegister();
        },
    },
  data() {
    return {
      availableCredit: 0,
      isSatAdmin: projectHelper.isSatAdmin(),
      isApi2Convert: projectHelper.isApi2Convert(),
    };
  },
};
</script>

<style lang="scss" scoped>
.free-credit-info {
  color: #1161e5;
}

.btn-login-outline {
  color: #1161e5;
  border: 2px solid #1161e5;
  -webkit-transition: background-color 200ms linear;
  -moz-transition: background-color 200ms linear;
  -o-transition: background-color 200ms linear;
  -ms-transition: background-color 200ms linear;
  transition: background-color 200ms linear;
  &:hover {
    background: #1161e5;
    color: white;
    .data-user-button-login {
      color: white;
    }
  }
  }
.user-badger {
  width: 170px;
  display:flex;
  color: #1161e5;
  border: 2px solid #1161e5;
  border-radius: 4px;
  justify-content: space-between;
  cursor: pointer;
  -webkit-transition: background-color 200ms linear;
  -moz-transition: background-color 200ms linear;
  -o-transition: background-color 200ms linear;
  -ms-transition: background-color 200ms linear;
  transition: background-color 200ms linear;
  &:hover {
    background: #1161e5;
    color: white;
    .data-user-button-login {
      color: white;
    }
  }
  .badger-icon {
    width: 40px;
    height: 43px;
    display:flex;
    align-items:center;
    justify-content:center;
    background: white;
    border-radius: 4px 0 0 4px;
    border-right: 3px solid black;
  }
  .badge-content {
    display: flex;
    width: 82px;
    flex-direction: column;
  }
  .badge-credits {
    background: #1161e5;
    color: white;
    svg {
      path {
        color: white;
      }
    }


    padding: 0 5px;
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 5px;
    border-radius: 0px 0 4px 0;
  }
  .badge-name {
    display: flex;
    height:100%;
    align-items:center;
    font-size: 12px;
    div {
      text-overflow: ellipsis;;
      overflow: hidden;
      white-space: nowrap;
      width: 90px;
      padding: 2px 2px;
      font-size: 12px;
    }
  }
  .badge-toggle {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      font-weight: bold;
    }
  }
}


</style>